import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetStockableItemsController::__invoke
* @see app/Http/Controllers/Item/GetStockableItemsController.php
* @route '/api/item/stock'
*/
const GetStockableItemsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStockableItemsController.url(options),
    method: 'get',
})

GetStockableItemsController.definition = {
    methods: ["get","head"],
    url: '/api/item/stock',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetStockableItemsController::__invoke
* @see app/Http/Controllers/Item/GetStockableItemsController.php
* @route '/api/item/stock'
*/
GetStockableItemsController.url = (options?: RouteQueryOptions) => {
    return GetStockableItemsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetStockableItemsController::__invoke
* @see app/Http/Controllers/Item/GetStockableItemsController.php
* @route '/api/item/stock'
*/
GetStockableItemsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStockableItemsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetStockableItemsController::__invoke
* @see app/Http/Controllers/Item/GetStockableItemsController.php
* @route '/api/item/stock'
*/
GetStockableItemsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetStockableItemsController.url(options),
    method: 'head',
})

export default GetStockableItemsController